import { useState, useRef } from "react";
import { safeTrace } from "../../../../lib/printer/giftCardPrintType";
import { message } from "antd";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import db from "../../../../database";
import { orderHistoryService, salesHistoryService, syncSingleProductByValue } from "../../../../services";
import { numberToWords } from "../../../../utils/numberToWords";
import messages from "../../../../errors/messages.en-IN.json";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useAuthStore from "../../../../stores/useAuthStore";
import { getCurrentTillId } from "../../../../utils/tillIdentity";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { getIsInterState } from "../../../../utils/taxUtils";
import { groupItemsByTaxRate } from "../utils/taxCalculations";

const useOrderHistory = ({
  tillData,
  authHeaders,
  precision,
  taxIncludeFlag,
  tillDataPaymentMethods,
  posConfig,
  cart,
  searchHistoryInput,
  setSearchhistoryInput,
  filteredDate,
  setFilterdDate,
  setFiltersFlag,
  metaDataRef,
  setMetaData,
  loading,
  setLoading,
  // setDetailsLoading,
}) => {
  const userData = useAuthStore((s) => s.userData) ?? {};
  const tillValue = useAuthStore((s) => s.tillValue);

  const [displayOrderHistory, setDisplayOrderHistory] = useState(false);
  const [orderHistoryDetails, setOrderHistoryDetails] = useState([]);
  const [ordersCopy, setOrdersCopy] = useState([]);
  const [selectDate, setSelectDate] = useState("");
  const [salesHistoryType, setSalesHistoryType] = useState([]);
  const [startRowData, setStartRowData] = useState({ startRow: "0", endRow: "10" });
  const [orderHistorySearchType, setOrderHistorySearchType] = useState("orderDocumentNo");
  const [selectedOrderHistoryLine, setSelectedOrderHistoryLine] = useState("");
  // const [loading, setLoading] = useState(false);
  const [orderHistoryInput, setOrderHistoryInput] = useState("");

  const prevHistoryRef = useRef(orderHistoryDetails);

  const changeOrderHistorySearchType = (value, e) => {
    setOrderHistorySearchType(value);
    setSelectDate(e);
  };

  const showOrderHistory = () => {
    db.orders
      .orderBy("orderTime")
      .limit(20)
      .reverse()
      .toArray()
      .then((data) => {
        setDisplayOrderHistory(true);
      });
  };

  const showOrderHistoryLine = (orderID) => {
    if (selectedOrderHistoryLine === orderID) {
      setSelectedOrderHistoryLine("");
    } else {
      setSelectedOrderHistoryLine(orderID);
    }
  };

  const getSalesHistoryData = async (order_id) => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    // setDetailsLoading(true);
    try {
      const data = {
        query: `query {salesHistoryDetails(
                    orderId: "${order_id}"
                  ) {
                    sOrderID
                    created
                    createdby
                    updated
                    updatedby
                    deliveryDate
                    documentno
                    invoiceNo
                    invoiceId
                    invoiceStatus
                    invoiceDate
                    salesRepID
                    dateordered
                    cwrProductQty
                    orderTime
                    taxamt
                    grosstotal
                    discAmount
                    layAway
                    creditSale
                    isReturn
                    paid
                    csUser {
                      user
                    }
                    csBUnit {
                      csBunitId
                      name
                    }
                    csbUnitLocation {
                      fulladdress
                    }
                    b2bOrder
                    cwrB2cCustomer {
                      cwrCustomerId
                      sPriceListId
                      code
                      name
                      mobileNo
                      pincode
                      email
                      retlLoyaltyBalance
                      iscredit
                      loyaltyLevelId
                      creditBalance
                      firstName
                      lastName
                      gender
                      taxId
                      birthday
                      anniversaryDate
                      b2cRegisteredstoreId
                      cardNumber
                      regType
                      validity
                      b2bCustomer
                      balancepoints
                      creditused
                      creditLimit
                      creditApproachPercentage
                      priceListName
                      customerList
                      loyaltyLevel {
                       cwrLoyaltyLevelId
                       name
                       accumulationRate
                       redemptionRate
                      }
                      cwrWallet {
                        wallet_Id
                        balance_Amt
                      }
                      sCustomer {
                        sCustomerID
                        customerCategory {
                          sCustomerCateforyId
                          value
                          name
                          description
                        }
                      }
                      b2cCustomerSegment {
                        cwrB2CCustomerSegmentId
                        name
                      }
                      metaData {
                        key
                        value
                      }
                    }
                    saleType {
                      cwrSaletypeId
                      name
                      value
                    }
                    cwrTill {
                      cwrTillID
                      till
                    }
                    tablename
                    fboRder {
                      guests
                    }
                    saLesRep {
                      waitername
                    }
                    finReceiptPlan {
                      finReceiptPlanDetails {
                        amount
                        transactionId
                        cardType
                        cardNo
                        transactionTime
                        authorizationCode
                        cwrPaymentmethod {
                          cWRPaymentMethodID
                          finFinancialAccountId
                          finPaymentmethodId
                          integratedPayment
                          isloyalty
                          paymentProvider
                        }
                      }
                    }
                    line {
                      sOrderlineID
                      sOrderId
                      line
                      description
                      qty
                      deliveryDate
                      netlist
                      netunit
                      created
                      linetax
                      unittax
                      unitprice
                      linenet
                      linegross
                      grosslist
                      grossstd
                      returnline
                      returnQty
                      discount
                      mBatchId
                      batchNo
                      product {
                        mProductId
                        name
                        value
                        upc
                        hsncode
                        imageurl
                        isManualQty
                        shortDescription
                        returnable
                        returnDays
                        productSegment
                      }
                      uom {
                        csUomId
                        name
                      }
                      tax {
                        csTaxID
                        name
                        rate
                      }
                      pricingRule {
                        mPricingrulesId
                        name
                      }
                      addons {
                        qty
                        price
                        name
                        addonProductId
                        value
                      }
                    }
                    metaData { key value }
                    additionalCharges {
                      sOrderAdditionalChargesId
                      sOrderId
                      name
                      amount
                    }
                  }
                }`,
      };
      const response = await salesHistoryService(data);
      // Processing the fetched data
      let totalQty = 0;
      const salesData = response?.data?.data?.salesHistoryDetails;
      if (salesData[0]?.metaData?.length > 0) {
        setMetaData(salesData[0].metaData);
        metaDataRef.current = salesData[0].metaData;
      }

      const arrayData = await Promise.all(
        response?.data?.data?.salesHistoryDetails?.map(async (item) => {
          const paymentMethods = [];
          let change = 0;
          let roundOff = 0;

          const itemSummery = {
            decimalItems: { totalQty: 0, totalAmount: 0 },
            nonDecimalItems: { totalQty: 0, totalAmount: 0 },
            itemsQty: 0,
            items: 0,
          };

          const isInterState = getIsInterState({ customer: item.cwrB2cCustomer });
          const groupedItemsByTaxRate = groupItemsByTaxRate(item.line || [], precision, { isInterState, taxField: "linetax", netField: "linegross" });

          let totalLineStd = 0;
          const lineItems = await Promise.all(
            item.line.map(async (pro) => {
              const allProductObjs = await db.products.where("mProductId").equals(pro.product.mProductId).toArray();
              let productObj = allProductObjs.filter((product) => product.productSegment !== "BG")[0] || null;
              // Out-of-stock items are skipped during product sync, so they are absent from IndexedDB
              // and the detail row would render blank. Fetch the product from the server by SKU value
              // (ignoreLastSync so it isn't filtered out by lastSyncTime) and re-read it.
              if (!productObj && pro.product?.value) {
                try {
                  const syncId = uuidv4().replace(/-/g, "").toUpperCase();
                  const tillId = tillData?.tillAccess?.cwrTill?.cwrTillID;
                  await syncSingleProductByValue(tillData, syncId, tillId, pro.product.value, { ignoreLastSync: true });
                  const refetched = await db.products.where("mProductId").equals(pro.product.mProductId).toArray();
                  productObj = refetched.filter((product) => product.productSegment !== "BG")[0] || null;
                } catch (err) {
                  console.error("syncSingleProductByValue fallback failed (order history):", err);
                }
              }
              const matchedGiftCardData = await db.giftCardData.toArray().then((giftCardData) => giftCardData.find((giftcard) => giftcard.mProductId === item.mProductId));
              if (matchedGiftCardData) {
                safeTrace("reprint: order history line matched a gift card type", { productId: item.mProductId || null, group: matchedGiftCardData.giftCardGroup || null, giftCardType: matchedGiftCardData.type || null });
              }

              // Undiscounted lines: grossstd carries its own independent backend rounding that
              // can drift a paisa from the actual charged amount (e.g. grossstd=166.94 vs the
              // true linegross/qty=166.95), showing up as a Price/Amount mismatch on the receipt.
              // Only trust grossstd (the pre-discount price, per BUG-1558) when the line actually
              // had a discount — there it legitimately differs from netunit by design and the
              // paisa-level noise is immaterial. Otherwise use the exact nettotal-derived value.
              const preDiscountUnitPrice = pro.discount > 0 ? pro.grossstd || pro.netunit || 0 : pro.qty > 0 ? (pro.linegross || 0) / pro.qty : pro.grossstd || pro.netunit || 0;

              if (Array.isArray(pro.children) && pro.children.length > 0) {
                pro.children.forEach((child) => {
                  const isDecimal = pro.uomData?.[0]?.decimal === "Y" || pro?.isDecimal;
                  const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

                  itemSummery.itemsQty += child.qty;
                  itemSummery.items += 1;
                  itemSummery[summaryKey].totalQty += child.qty;
                  itemSummery[summaryKey].totalAmount += child.linegross;
                });
              } else {
                const isDecimal = pro.uomData?.[0]?.decimal === "Y" || pro.isDecimal;
                const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";

                itemSummery.itemsQty += pro.qty;
                itemSummery.items += 1;
                itemSummery[summaryKey].totalQty += pro.qty;
                itemSummery[summaryKey].totalAmount += pro.linegross;
              }

              // linestd is what print templates bind their item-table "Total" column to
              // (e.g. Al Aqad's dataMapping total:"linestd") for a retrieved Layaway/Advance/
              // Credit-Sale line. Same grossstd unreliability as preDiscountUnitPrice above:
              // confirmed live on OFC-Live and gpr-live that grossstd*qty routinely doesn't
              // match linegross even on undiscounted lines (grossstd isn't a reliable gross
              // value there despite the name), which printed the tax-exclusive amount as the
              // line Total instead of the tax-inclusive one. An undiscounted line's Total must
              // equal linegross by definition -- there's no discount to create a std-vs-actual
              // gap -- so skip grossstd there too, same as preDiscountUnitPrice already does.
              const linestd =
                pro.discount > 0
                  ? pro.grossstd != null
                    ? pro.grossstd * pro.qty
                    : taxIncludeFlag === "Y"
                      ? productObj?.sunitprice
                        ? productObj?.sunitprice * pro.qty
                        : pro.linegross
                      : productObj?.sunitprice
                        ? productObj?.sunitprice * (1 + productObj?.taxRate / 100) * pro.qty
                        : pro.linegross
                  : pro.linegross || 0;

              const productDefined = {
                batchno: pro?.batchNo?.split("-:")[0] || pro?.batchNo || productObj?.batchno || null,
                description: productObj?.description || "",
                discount: pro?.discount ?? 0,
                discountName: pro?.pricingRule?.name || "",
                imageurl: productObj?.imageurl || "",
                isDecimal: productObj?.isDecimal || false,
                isManualQty: productObj?.isManualQty || false,
                restrictPosQtyEdit: productObj?.restrictPosQtyEdit || "N",
                showAlternateUomInPos: productObj?.showAlternateUomInPos || "N",
                interTaxId: productObj?.interTaxId || "",
                interTaxRate: productObj?.interTaxRate || 0,
                interTaxName: productObj?.interTaxName || "",
                alternateUom: productObj?.alternateUom || null,
                isPromoApplicable: productObj?.isPromoApplicable || false,
                deliveryDate: pro?.deliveryDate ? dayjs(pro?.deliveryDate).format("DD-MM-YYYY HH:mm:ss") : null,
                isReturn: false,
                mBatchId: pro?.mBatchId || null,
                giftCardType: matchedGiftCardData ? matchedGiftCardData?.type : null,
                mPricingruleId: null,
                name: (() => {
                  const baseName = productObj?.name || "";
                  if (productObj?.showAlternateUomInPos === "Y" || (pro.uom?.csUomId && productObj?.uomData?.[0]?.csUomId && pro.uom.csUomId !== productObj.uomData[0].csUomId)) {
                    return pro.uom?.name ? `${baseName} (${pro.uom.name})` : baseName;
                  }
                  return baseName;
                })(),
                name2: productObj?.name2 || "",
                nettotal: pro.linegross || 0,
                primaryOrderLine: null,
                productId: productObj?.mProductId || null,
                // netunit is the backend's tax-exclusive per-unit price (post-discount, what was
                // actually charged); unitprice is tax-inclusive for online/aggregator orders.
                // salePrice/sunitprice/originalPrice must carry the tax-exclusive netunit value
                // to match every live cart-item build path (cart.js), otherwise the printed Price
                // shows tax-inclusive while tax is also shown separately, and Price×Qty stops
                // matching the (correctly tax-exclusive) line Amount.
                //
                // realPrice/grossunit are different: BUG-1558 requires the receipt's unit-Price
                // column to show the pre-discount standard price, not the discounted one (the
                // discount total is called out separately via grossTotal). See preDiscountUnitPrice
                // above for why this isn't simply pro.grossstd.
                realPrice: preDiscountUnitPrice,
                listPrice: productObj?.slistprice || 0,
                sunitprice: pro?.netunit || 0,
                returnQty: null,
                originalPrice: pro?.netunit || 0,
                productSegment: pro?.product?.productSegment || "",
                salePrice: pro?.netunit || 0,
                // grossunit is the unit-price field print templates bind to (mirrors every live
                // cart-item build path, e.g. cart.js/useCartOperations.js) — was missing entirely
                // for order-history/aggregator reconstructed lines, leaving the printed Price blank.
                // See preDiscountUnitPrice above for why this isn't simply pro.grossstd.
                grossunit: preDiscountUnitPrice,
                stock: productObj?.onhandQty || 0,
                tax: productObj?.cTaxId || null,
                taxCategory: productObj?.taxCategory || "",
                taxName: productObj?.taxName || "",
                taxFlag: productObj?.taxFlag || "N",
                taxAmount: pro.linetax || 0,
                taxRate: productObj?.taxRate || 0,
                // TIC-7676 follow-up: the retrieved order line already carries the UOM it was
                // actually sold in (pro.uom, requested above for the alternate-UOM name check) --
                // prefer that over the product's base UOM, which was silently overwriting it here
                // and shipping the wrong UOM to confirmPOSLayawayOrder1 on Advance/Layaway close
                // (root cause of GPR-live negative stock: alternate-UOM sales closing as base UOM).
                uom: pro.uom?.csUomId || productObj?.csUomId || null,
                uom_name: pro.uom?.name || productObj?.uomName || "",
                addNewLine: productObj?.addNewLine || "N",
                customAttributes: productObj?.customAttributes || [],
                preparationTime: productObj?.preparationTime || "",
                printerId: productObj?.printerId || "",
                showAddons: productObj?.showAddons || false,
                foodType: productObj?.foodType || "",
                itemType: productObj?.itemType || "",
                type: productObj?.type || "",
                newCustomAttributes: [],
                priceList: productObj?.priceList || [],
                addons: pro.addons || [],
                selectedAddons: [],
                isDecimalQty: productObj?.uomData?.[0]?.decimal === "Y",
                isQtyDesimal: productObj?.uomData?.[0]?.stdprecision ?? 2,
                upc: pro.product?.upc || null,
                value: productObj?.value || null,
                weight: pro.qty || 0,
                order: "N",
                productionCenter: productObj?.productionCenter || "",
                productionCenterId: productObj?.productionCenterId || "",
                shortDescription: productObj?.shortDescription || "",
                hsncode: productObj?.hsncode || null,
                csBunitId: productObj?.csBunitId || null,
                mProductCategoryId: productObj?.mProductCategoryId || null,
                productManufacturerId: productObj?.productManufacturerId || null,
                productBrandId: productObj?.productBrandId || null,
                productBrandName: productObj?.productBrandName || null,
                productCategoryName: productObj?.productCategoryName || "",
                productAddons: productObj?.productAddons || [],
                batchedProduct: productObj?.batchedProduct || false,
                batchedForSale: productObj?.batchedForSale || false,
                batchedForStock: productObj?.batchedForStock || false,
                multiPrice: productObj?.multiPrice === "Y" ? "Y" : "N",
                shelfLife: productObj?.shelfLife || 0,
                stdTax: productObj?.sunitprice * (1 + productObj?.taxRate / 100),
                lineId: uuidv4().replace(/-/g, "").toUpperCase(),
                layAway: item.layAway || "N",
                linestd,
                uomData: productObj?.uomData || [],
              };
              totalLineStd += linestd;

              return { ...pro, ...productDefined };
            })
          );

          // Reconstruct Custom Mix parent-child grouping from order metaData
          let processedLineItems = lineItems;
          const customMixMetaEntry = item.metaData?.find((m) => m.key === "Custom Mix");
          if (customMixMetaEntry?.value) {
            try {
              const customMixGroups = JSON.parse(customMixMetaEntry.value);
              if (Array.isArray(customMixGroups) && customMixGroups.length > 0) {
                const lineItemByOrderlineId = new Map(lineItems.map((li) => [li.sOrderlineID, li]));
                const allChildIds = new Set();
                const syntheticParents = [];

                for (const group of customMixGroups) {
                  const childIds = (group.children || []).map((c) => c.sOrderlineID);
                  const children = childIds
                    .map((id) => lineItemByOrderlineId.get(id))
                    .filter(Boolean)
                    // Custom Mix children only: realPrice above is BUG-1558's pre-discount
                    // gross price (what printed receipts read via grossstd/linestd, not
                    // realPrice — confirmed against the print template's dataMapping). But
                    // SMCartTable's live cart Price column reads realPrice expecting the
                    // tax-exclusive net unit price, same as every normally-added cart item
                    // (cart.js). salePrice/sunitprice already carry that correct value
                    // (pro.netunit, see productDefined above) — reuse it here instead of
                    // BUG-1558's preDiscountUnitPrice. Scoped to Custom Mix children only:
                    // regular (non-grouped) lines keep BUG-1558's realPrice untouched, and
                    // matched children are removed from processedLineItems below, so this
                    // override never surfaces alongside the original BUG-1558 value.
                    .map((child) => ({ ...child, realPrice: child.salePrice }));
                  if (children.length === 0) continue;

                  childIds.forEach((id) => allChildIds.add(id));
                  const nettotal = group.nettotal || 0;
                  const weight = group.weight || 1;
                  const insertAt = lineItems.findIndex((li) => li.sOrderlineID === childIds[0]);

                  const taxAmount = group.taxAmount || 0;
                  syntheticParents.push({
                    insertAt,
                    parentItem: {
                      name: group.name || "Custom Mix",
                      weight,
                      grossstd: weight > 0 ? nettotal / weight : 0,
                      linestd: nettotal,
                      taxAmount,
                      discount: group.discount || 0,
                      nettotal,
                      hsncode: null,
                      taxRate: 0,
                      uom_name: "",
                      productId: null,
                      lineId: uuidv4().replace(/-/g, "").toUpperCase(),
                      sOrderlineID: null,
                      children,
                      // SMCartTable's Price column reads realPrice (and the View Details
                      // modal's "Unit Price" column reads salePrice) — without these the
                      // synthetic parent renders Price as NaN.
                      sunitprice: nettotal,
                      salePrice: nettotal - taxAmount,
                      realPrice: nettotal - taxAmount,
                    },
                  });
                }

                processedLineItems = lineItems.filter((li) => !allChildIds.has(li.sOrderlineID));

                for (const { parentItem, insertAt } of syntheticParents.sort((a, b) => a.insertAt - b.insertAt)) {
                  const adjustedIndex = lineItems.slice(0, insertAt).filter((li) => !allChildIds.has(li.sOrderlineID)).length;
                  processedLineItems.splice(Math.min(adjustedIndex, processedLineItems.length), 0, parentItem);
                }
              }
            } catch (e) {
              console.error("[OrderHistory] Failed to reconstruct Custom Mix grouping:", e);
            }
          }

          let paidAmount = 0;
          item?.finReceiptPlan?.[0]?.finReceiptPlanDetails?.forEach((ele) => {
            const paymentMethod = tillDataPaymentMethods.find((pi) => pi.finPaymentmethodId === ele.cwrPaymentmethod.finPaymentmethodId);
            if (paymentMethod && ele.amount > 0) {
              paymentMethods.push({
                ...paymentMethod,
                amount: parseFloat(parseFloat(ele.amount)?.toFixed(precision)),
                advancePayment: parseFloat(parseFloat(ele.amount)?.toFixed(precision)),
                transactionId: ele.transactionId || "",
                cardType: ele.cardType || "",
                cardNo: ele.cardNo || "",
                transactionTime: ele.transactionTime ? dayjs(ele.transactionTime).format("DD-MM-YYYY HH:mm:ss") : "",
                authorizationCode: ele.authorizationCode || "",
              });
              paidAmount += ele.amount;
            } else if (ele.amount < 0) {
              change = ele.amount;
            }
          });
          salesData?.forEach((item) => {
            const paymentDetailsMeta = item.metaData?.find((meta) => meta.key === "Payment Details");
            const paymentDetails = paymentDetailsMeta ? JSON.parse(paymentDetailsMeta.value) : [];
            const changeObj = paymentDetails.find((detail) => detail.change !== undefined && detail.change !== null);
            change = changeObj ? changeObj.change : 0;
          });
          // BUG-2315 (TIC-10099): this used to be Math.ceil(grosstotal) - grosstotal (BUG-1397,
          // f63243f4c) -- a blunt "round up to the next whole currency unit" fabrication
          // with no basis in any actual rounding rule (not cs_currency.roundingMethod, not
          // roundOffForPos denomination tendering). It has nothing to do with the order's
          // real round-off; grosstotal here is already the true, correct order total
          // (confirmed via direct DB check against s_order for multiple orders). Feeding a
          // fabricated non-zero roundOff into a retrieved Layaway/Advance/Credit-Sale cart
          // let dataIntegrity.js's reconcileOrderTotalDrift (added later, BUG-1965,
          // b92b8effb) mistake it for a genuine header/line mismatch and "self-heal" a
          // perfectly correct line item by that same fabricated amount -- reported back as
          // the item's nettotal/linegross jumping by ~AED 0.75 on completion print/save
          // (order SSZR0410548 and others, OFC-QA). The order's real round-off, if any, is
          // already captured correctly elsewhere (e.g. the "Round Off" field in the order's
          // own Payment Details meta) -- there is no legitimate non-zero value to compute
          // here, so this always reports 0 instead of inventing one.
          roundOff = 0;
          // TSK-2956: additionalCharges may be null/undefined/empty depending on order source
          const packingCharge = Array.isArray(item.additionalCharges) ? item.additionalCharges.reduce((sum, charge) => sum + (Number(charge?.amount) || 0), 0) : 0;
          const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
          const selectedPriceListId = item?.cwrB2cCustomer?.sPriceListId ?? saleTypeData?.customer?.sPriceListId;
          return {
            change,
            items: processedLineItems || [],
            cardPaymentData: {},
            originalPrice: item.grosstotal || 0,
            customer: { ...item.cwrB2cCustomer, sPriceListId: selectedPriceListId } || "",
            b2bOrder: item?.b2bOrder || "N",
            documentno: item.documentno,
            salesRepID: item.salesRepID,
            total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
            discount: item.discAmount || 0,
            tax: item.taxamt || 0,
            deliveryDate: item?.deliveryDate ? dayjs(item?.deliveryDate).format("DD-MM-YYYY HH:mm:ss") : null,
            orderTime: item.orderTime ? dayjs(item.orderTime).format("DD-MM-YYYY HH:mm:ss") : null,
            orderDate: item.dateordered,
            totalQty: item.cwrProductQty,
            payments: [],
            paymentData: paymentMethods || [],
            roundOff: roundOff,
            sOrderID: item.sOrderID,
            key: item.documentno,
            salesHistory: "Y",
            status: "Success",
            isSynced: 0,
            creditAmount: 0,
            createdBy: "",
            layAway: item?.layAway || "N",
            creditSale: item?.creditSale || "N",
            isReturn: item?.isReturn || "N",
            paid: paidAmount || 0,
            advancePayment: paidAmount || 0,
            redemptionPoints: 0,
            accumulationPoints: 0,
            saleType: item.saleType || {},
            tableNo: item.tablename || "",
            referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
            userName: userData?.user || "",
            tillName: tillValue?.name,
            // grosstotal already has additionalCharges (e.g. TCS) folded in, so subtracting
            // only taxamt left a "subTotal" that was really subtotal+additionalCharges. That
            // contaminated value flows unchanged into the cart on Retrieve Credit Sale
            // (useParkedBills.js selectLayAwayOrder), where useAdditionalCharges.js recomputes
            // TCS from scratch and adds it on top again -- double-counting the charge on the
            // retrieved total. Subtract additionalCharges here too so subTotal is the clean
            // pre-tax/pre-charges figure every other consumer already assumes it is.
            subTotal: parseFloat(
              parseFloat(
                item?.grosstotal -
                  item?.taxamt -
                  (Array.isArray(item.additionalCharges) ? item.additionalCharges.reduce((s, c) => s + (Number(c?.amount) || 0), 0) : 0) || 0
              )?.toFixed(precision)
            ),
            itemsSummery: itemSummery,
            amountInWords: numberToWords(item?.grosstotal || 0),
            groupedItemsByTaxRate: groupedItemsByTaxRate,
            totalStd: Math.ceil(item.grosstotal || 0),
            packingCharge: parseFloat(packingCharge.toFixed(precision)),
            additionalCharges: item.additionalCharges || [],
          };
        })
      );
      if (arrayData.length > 0) {
        // Create a new array by updating or adding records
        const updatedOrderDetails = orderHistoryDetails.map((order) => {
          // Check if the current order matches any entry in arrayData
          const matchingData = arrayData.find((newData) => newData.sOrderID === order.sOrderID);
          return matchingData ? { ...order, ...matchingData } : order; // Update if match found
        });

        // Update state with the new array
        setOrderHistoryDetails(updatedOrderDetails);
        setOrdersCopy(updatedOrderDetails);
      }

      // setDetailsLoading(false);
      return arrayData;
    } catch (error) {
      console.error("Error fetching order history:", error);
      // Handle error appropriately, for example, set a state to show an error message
    } finally {
      // setDetailsLoading(false);
    }
    setOrderHistoryInput("");
  };

  const searchOrderHistory = async (date, dateValue, row, flag, dateFlag, deliveryDateValue = []) => {
    let setAuthTokens;
    let startDate;
    let endDate;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    const sortOptions = {
      documentno: "desc",
      dateordered: "desc",
      customer: null,
      totalAmount: null,
    };
    const filteredSortOptions = Object.fromEntries(Object.entries(sortOptions).filter(([key, value]) => value !== null));
    // if (Array.isArray(dateValue) && dateValue.length > 0) {
    //   // Support both Dayjs (from Ant Design v5 RangePicker) and Moment objects.
    //   // dayjs(dayjsObj) silently returns "now", collapsing both dates to the
    //   // same value. Use each object's own .format() instead. (Issue #1)
    //   const toDateStr = (val) => {
    //     if (!val) return null;
    //     if (moment.isMoment(val)) return val.format("YYYY-MM-DD");
    //     if (typeof val.format === "function") return val.format("YYYY-MM-DD"); // Dayjs
    //     if (typeof val === "string") return dayjs(val).format("YYYY-MM-DD");
    //     return dayjs(val).format("YYYY-MM-DD");
    //   };
    //   startDate = toDateStr(dateValue[0]);
    //   endDate = toDateStr(dateValue[1]);
    //   if (!startDate || !endDate || startDate === "Invalid date" || endDate === "Invalid date") {
    //     console.error("[searchOrderHistory] Invalid dateValue, aborting:", dateValue);
    //     return;
    //   }
    //   // Store as moment objects for transaction store compatibility
    //   const start = dayjs(startDate, "YYYY-MM-DD");
    //   const end = dayjs(endDate, "YYYY-MM-DD");
    //   useTransactionStore.getState().setOrderType([date, [start, end]]);
    // }
    const fmtDate = (d) => (d === null || d === undefined ? "null" : `\\"${d}\\"`);
    const resolveDateStr = (d) => (d === null ? null : d?.format ? d.format("YYYY-MM-DD") : dayjs(d).format("YYYY-MM-DD"));

    if (Array.isArray(dateValue) && dateValue.length > 0) {
      // Persist the active filter in a dedicated store field (not the sale's orderType)
      // so scroll pagination can re-issue the same query for the following page.
      useTransactionStore.getState().setSalesHistoryFilter([date, dateValue]);
      startDate = resolveDateStr(dateValue[0]);
      endDate = resolveDateStr(dateValue[1]);
    }
    let deliveryStartDate = startDate;
    let deliveryEndDate = endDate;

    if (deliveryDateValue?.length > 0) {
      deliveryStartDate = resolveDateStr(deliveryDateValue[0]);
      deliveryEndDate = resolveDateStr(deliveryDateValue[1]);
    }

    const productSearchInput = document.getElementById("sm-salesHistory-customer");
    if (productSearchInput) {
      productSearchInput.focus();
    }
    const isPreOrderPage = window.location.pathname.includes("/preorder");
    let dateFiltered;
    if (isPreOrderPage) {
      dateFiltered = `"{\\"DateRange\\":[${fmtDate(startDate)},${fmtDate(endDate)}],\\"DeliveryDateRange\\":[${fmtDate(deliveryStartDate)},${fmtDate(deliveryEndDate)}]}"`;
    } else {
      dateFiltered = `"{\\"DateRange\\":[${fmtDate(startDate)},${fmtDate(endDate)}]}"`;
    }
    const sortData = JSON.stringify(filteredSortOptions).replace(/"/g, '\\"');
    const isCallCenterPage = window.location.pathname.includes("/call-center");
    // Captured for the date-search branch and returned at the end so scroll handlers can
    // advance the pagination offset, without skipping the shared cleanup below.
    let dateSearchResponse;
    if (date === "orderDateSearchKey") {
      setLoading(true);
      try {
        const startRow = row;
        const endRow = parseInt(startRow, 10) + 50;
        const specificStores = posConfig?.showStoreSpecificRecords === "Y" ? true : false;
        // BUG-2100: showStoreSpecificRecords only governs SEARCH scope. A plain listing
        // (no search term) must always stay scoped to the current till, otherwise an
        // "N" store opens Sales History onto every till's orders. A request only counts
        // as a search when a non-empty q is sent — the call-centre customer lookup and
        // a typed customer/document term both qualify, an empty box does not.
        const isCallCentreSearch = posConfig?.enableCallCentre === "Y" && isCallCenterPage;
        const searchTerm = isCallCentreSearch ? cart.customer.code : searchHistoryInput?.trim() || "";
        const isSearch = isCallCentreSearch || searchTerm !== "";
        const sendTillId = specificStores || !isSearch;
        const data = {
          query: `query {salesHistory(
                    q: ${isSearch ? `"${searchTerm}"` : null},
                    filter_by: ${dateFiltered},
                    startRow: "${startRow}",
                    endRow: "${endRow}",
                    sort_by: "${sortData}",
                    tillId: ${sendTillId ? `"${getCurrentTillId()}"` : null},
                    layAway: "${isPreOrderPage ? "Y" : "N"}"
                  ) {
                  sOrderID
                  documentno
                  invoiceNo
                  invoiceId
                  invoiceStatus
                  invoiceDate
                  dateordered
                  totalQty
                  orderTime
                  grosstotal
                  layAway
                  isReturn
                  docstatus
                  creditSale
                  estimateDocumentNo
                  saleType {
                    cwrSaletypeId
                    name
                    value
                  }
                  deliveryDate
                  cwrB2cCustomer {
                    cwrCustomerId
                    code
                    name
                    mobileNo
                    pincode
                    email
                    retlLoyaltyBalance
                    loyaltyLevelId
                    creditBalance
                    creditApproachPercentage
                    loyaltyLevel {
                      name
                    }
                    cwrWallet {
                      wallet_Id
                      balance_Amt
                    }
                    sCustomer {
                      sCustomerID
                      customerCategory {
                        sCustomerCategoryId
                        value
                        name
                        description
                      }
                    }
                  }
                  cwrTill {
                    till
                  }
                }
                }
                `,
        };
        const orderHistoryData = await orderHistoryService(data);

        if (orderHistoryData?.data?.data?.salesHistory.length === 0) {
          message.error(`${messages.errors.cart.no_more_records}`);
          setFiltersFlag(true);
          setLoading(false);
        } else {
          setFilterdDate(dateFiltered);
          const isPreOrderPage = window.location.pathname.includes("/preorder");
          const arrayData = await Promise.all(
            orderHistoryData?.data?.data?.salesHistory
              ?.filter((item) => {
                // Only hide PENDING advance orders from POS sales history.
                // A completed advance order has invoiceNo set (the final HSN receipt number)
                // and should appear in regular sales history alongside normal invoices.
                if (!isPreOrderPage && posConfig?.enablePreOrder === "Y" && item.layAway === "Y" && !item.invoiceNo) {
                  return false;
                }
                return true;
              })
              ?.map(async (item) => {
                const obj = {
                  change: 0,
                  items: [],
                  cardPaymentData: {},
                  originalPrice: item.grosstotal || 0,
                  customer: item.cwrB2cCustomer || "",
                  documentno: item.documentno,
                  estimateDocumentNo: item.estimateDocumentNo || "",
                  total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
                  discount: item.discAmount || 0,
                  tax: item.taxamt || 0,
                  orderTime: item.orderTime,
                  orderDate: item.dateordered,
                  totalQty: item.totalQty || 0,
                  payments: [],
                  paymentData: [],
                  roundOff: 0,
                  sOrderID: item.sOrderID,
                  key: item.documentno,
                  salesHistory: "Y",
                  status: "Success",
                  isSynced: 0,
                  creditAmount: 0,
                  createdBy: "",
                  layAway: item.layAway || "N",
                  creditSale: item.creditSale || "N",
                  isReturn: item.isReturn || "N",
                  docstatus: item.docstatus,
                  deliveryDate: item.deliveryDate,
                  saleType: item.saleType || {},
                  invoiceNo: item.invoiceNo || "",
                  invoiceId: item.invoiceId || "",
                  invoiceStatus: item.invoiceStatus || "",
                  invoiceDate: item.invoiceDate || "",
                  paid: 0,
                  advancePayment: 0,
                  redemptionPoints: 0,
                  accumulationPoints: 0,
                  referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                  userName: userData?.user || "",
                  tillName: tillValue?.name,
                  subTotal: 0,
                  itemsSummery: {},
                  amountInWords: "",
                  groupedItemsByTaxRate: {},
                };

                return obj;
              })
          );

          setOrderHistoryDetails((prevData) => {
            const existingOrderIds = new Set(prevData.map((order) => order.sOrderID));
            const uniqueNewOrders = arrayData.filter((order) => !existingOrderIds.has(order.sOrderID));
            return [...prevData, ...uniqueNewOrders];
          });
          setOrdersCopy((prevData) => {
            const existingOrderIds = new Set(prevData.map((order) => order.sOrderID));
            const uniqueNewOrders = arrayData.filter((order) => !existingOrderIds.has(order.sOrderID));
            return [...prevData, ...uniqueNewOrders];
          });
          setFiltersFlag(dateFlag ? false : true);
          // Advance the pagination offset to an ABSOLUTE position (the page's startRow
          // plus the rows the server returned) so the next scroll continues from here.
          // Absolute (not +=) keeps it correct for every entry point — including the
          // ones that don't pre-reset dataLength — so the first scroll neither skips a
          // page nor re-requests the current one. Without this the offset never moved
          // and a large date-range list appeared to stop loading after page one.
          const fetchedRows = orderHistoryData?.data?.data?.salesHistory?.length || 0;
          localStorage.setItem("dataLength", String(parseInt(startRow, 10) + fetchedRows));
          setLoading(false);
        }
        // Capture the raw response so scroll handlers that key off it (e.g. Restaurant's
        // OrderHistoryList, which stops paging when the page comes back empty) can react.
        dateSearchResponse = orderHistoryData;
      } catch (error) {
        console.error("Error fetching order history data:", error);
        setLoading(false);
      }
    } else {
      setLoading(true);
      setOrderHistoryDetails([]);
      prevHistoryRef.current = orderHistoryDetails;
      // Clear the date-range filter: this branch handles customer/document/clear
      // searches, which are not offset-paginated by the scroll handlers. Leaving a
      // stale filter set would let a later scroll wrongly re-issue the date query.
      useTransactionStore.getState().setSalesHistoryFilter(null);
      localStorage.setItem("dataLength", "100");
      const specificStores = posConfig?.showStoreSpecificRecords === "Y" ? true : false;
      // BUG-2100: same rule as the date branch — this path serves both an actual
      // customer/document search and the "search cleared" re-listing (q === ""). Only
      // the former may go global under showStoreSpecificRecords = "N".
      const searchTerm = dateValue.trim();
      const sendTillId = specificStores || searchTerm === "";
      try {
        const data = {
          query: `query { salesHistory(
              q: "${searchTerm}",
              filter_by: ${flag ? filteredDate : null},
              startRow: "0",
              endRow: "100",
              sort_by: "${sortData}",
              tillId: ${sendTillId ? `"${getCurrentTillId()}"` : null},
              layAway: "${isPreOrderPage ? "Y" : "N"}"
            ) {
                  sOrderID
                  documentno
                  invoiceNo
                  invoiceId
                  invoiceStatus
                  invoiceDate
                  dateordered
                  totalQty
                  orderTime
                  grosstotal
                  layAway
                  isReturn
                  docstatus
                  creditSale
                  estimateDocumentNo
                  saleType {
                    cwrSaletypeId
                    name
                    value
                  }
                  deliveryDate
                  cwrB2cCustomer {
                    cwrCustomerId
                    code
                    name
                    mobileNo
                    pincode
                    email
                    retlLoyaltyBalance
                    loyaltyLevelId
                    creditBalance
                    creditApproachPercentage
                    loyaltyLevel {
                      name
                    }
                    cwrWallet {
                      wallet_Id
                      balance_Amt
                    }
                    sCustomer {
                      sCustomerID
                      customerCategory {
                        sCustomerCategoryId
                        value
                        name
                        description
                      }
                    }
                  }
                  cwrTill {
                    till
                  }
                }
                }`,
        };
        const response = await orderHistoryService(data);

        // Processing the fetched data
        const arrayData = await Promise.all(
          response?.data?.data?.salesHistory?.map(async (item) => {
            return {
              change: 0,
              items: [],
              cardPaymentData: {},
              originalPrice: item.grosstotal || 0,
              customer: item.cwrB2cCustomer || "",
              documentno: item.documentno,
              estimateDocumentNo: item.estimateDocumentNo || "",
              total: parseFloat(parseFloat(item.grosstotal || 0)?.toFixed(precision)),
              discount: item.discAmount || 0,
              tax: item.taxamt || 0,
              orderTime: item.orderTime,
              orderDate: item.dateordered,
              totalQty: item.cwrProductQty || item.totalQty,
              payments: [],
              paymentData: [],
              roundOff: 0,
              sOrderID: item.sOrderID,
              key: item.documentno,
              salesHistory: "Y",
              status: "Success",
              isSynced: 0,
              creditAmount: 0,
              createdBy: "",
              layAway: item?.layAway || "N",
              creditSale: item.creditSale || "N",
              isReturn: item?.isReturn || "N",
              docstatus: item.docstatus,
              deliveryDate: item.deliveryDate,
              saleType: item.saleType || {},
              invoiceNo: item.invoiceNo || "",
              invoiceId: item.invoiceId || "",
              invoiceStatus: item.invoiceStatus || "",
              invoiceDate: item.invoiceDate || "",
              paid: 0,
              advancePayment: 0,
              redemptionPoints: 0,
              accumulationPoints: 0,
              referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
              userName: userData?.user || "",
              tillName: tillValue?.name,
              subTotal: 0,
              itemsSummery: {},
              amountInWords: "",
              groupedItemsByTaxRate: {},
            };
          })
        );

        setOrdersCopy(arrayData);
        setOrderHistoryDetails(arrayData);
        setFiltersFlag(!dateFlag);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching order history:", error);
        // Handle error appropriately, for example, set a state to show an error message
      } finally {
        setLoading(false);
      }
    }

    setOrderHistoryInput("");
    // undefined for non-date searches; the fetched page for date searches so scroll
    // handlers (SuperMarket / Restaurant / Preorder) can advance the offset.
    return dateSearchResponse;
  };

  return {
    // State
    displayOrderHistory,
    setDisplayOrderHistory,
    orderHistoryDetails,
    setOrderHistoryDetails,
    ordersCopy,
    setOrdersCopy,
    selectDate,
    setSelectDate,
    salesHistoryType,
    setSalesHistoryType,
    startRowData,
    setStartRowData,
    orderHistorySearchType,
    setOrderHistorySearchType,
    selectedOrderHistoryLine,
    setSelectedOrderHistoryLine,
    // loading,
    // setLoading,
    orderHistoryInput,
    setOrderHistoryInput,
    prevHistoryRef,

    // Handlers
    changeOrderHistorySearchType,
    showOrderHistory,
    showOrderHistoryLine,
    getSalesHistoryData,
    searchOrderHistory,
  };
};

export default useOrderHistory;
